class SDC_Form_Handler {

	FILTER = {
		text: /[A-Za-z\s]/,
		number: /[0-9]/,
		url: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&’\(\)\*\+,;=.]+$/i,
		email: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
	}

	KEY = {
		Escape: 'Escape',
		ArrowLeft: 'ArrowLeft',
		ArrowRight: 'ArrowRight',
		ArrowUp: 'ArrowUp',
		ArrowDown: 'ArrowDown',
		Enter: 'Enter',
		Delete: 'Delete',
		Backspace: 'Backspace',
		Tab: 'Tab',
		Space: 'Space',
	}

	IS_VALID = false

	constructor(form, callbackFunction) {
		this.form = form
		this.callbackFunction = callbackFunction

		if (!this.form && 'object' !== typeof this.form) return

		this.init()
	}

	init() {
		this.handleKeyDown()
		this.handleInput()
		this.submit()
	}

	// Get all fields
	get fields() {
		// Get all form fields
		return this.form.elements
	}

	// Get radio buttons names
	get radioButtonsName() {
		let radioNames = [], // Create empty array
			radioButtons = Array.prototype.filter.call(this.fields, field => field.type === 'radio') // Get all input type=radio

		
		radioButtons.filter(radioButton => radioNames.push(radioButton.name))

		return radioNames.filter(this.unique)
	}

	// Get unique value 
	unique(value, index, self) {
		return self.indexOf(value) === index
	}

	// RegExp pattern validation
	regExpValidation() {
		Array.prototype.filter.call(this.fields, field => {
			if ('' === field.value) return
			let filterName = field.dataset.filter,
				filter = this.FILTER[filterName]

			if (filter && filter.test(field.value) === false) {
				
				this.highlight(field, false, 'invalid')
				this.IS_VALID = false
			}
		})
	}

	// Prevent typing non-letters in input type text 
	handleKeyDown() {
		this.form.addEventListener('keydown', (event) => {

			let filterName = event.target.dataset.filter,
				filter = this.FILTER[filterName]

			if ( filterName !== ('text' || 'number') ) return false

			if (filter && 
				!filter.test(event.key) &&
				![ this.KEY.Backspace, this.KEY.Delete, this.KEY.ArrowLeft, this.KEY.ArrowRight ].includes( event.code ) ) {
				event.preventDefault();
			}
		})
	}

	// Hide the error message after input data
	handleInput() {
		Array.prototype.map.call(this.fields, field => {
			field.addEventListener('input', () => this.highlight(field, true, ['empty', 'invalid', 'notvalid']))
		})
	}

	// Highlight Field
	highlight(field, isValid, className = 'empty' ) {
		if (isValid) {
			field.closest('.form-item').classList.remove(...className)
		} else {
			field.closest('.form-item').classList.add(className)
		}
	}

	// Validate unchecked radio buttons
	validataRadio() {
		let radioButton = this.fields[this.radioButtonsName]
		if (! radioButton || ( radioButton && '' !== radioButton.value ) ) return
		this.highlight(radioButton[0], false)
		this.IS_VALID = false
	}

	// Validate empty inputs
	requireInputs() {
		let elements = this.fields
		let invalids = Array.prototype.filter.call(elements, element => element.value === '')

		invalids.map(invalid => this.highlight(invalid, false))
		if (invalids.length > 0) {
			this.IS_VALID = false
		} else {
			this.IS_VALID = true
		}

	}

	// Send form data
	sendFormData() {
		let formData = new FormData(this.form)
		formData.append('action', 'sdc_form_handler')
		formData.append('form_id', this.form.id)

		let param = new URLSearchParams(formData).toString()

		postData(surprise_ajax_params.ajaxurl, param)
			.then(data => {
				return data
			})
	}

	// Submit
	submit() {
		this.form.addEventListener('submit', (event) => {
			event.preventDefault()

			this.requireInputs()
			this.validataRadio()
			this.regExpValidation()

			if (!this.IS_VALID){
				this.form.classList.add('has-errors')
			} else {
				this.form.classList.remove('has-errors')
			} 
			setTimeout(() => {this.form.classList.remove('has-errors')}, 1200);

			// if (!this.#IS_VALID) throw new Error('Form data is invalid')
			if (!this.IS_VALID) return

			if ( this.callbackFunction && 'function' === (typeof this.callbackFunction) ) {
				this.callbackFunction()
			}

			this.sendFormData()

			if ( this.form.name !== 'sdc_form_signup') {
				this.form.reset()
			}
			this.form.classList.add('sent')
		})
	}

}
